<template>
  <div>
    <div v-if="show==1">
      <div class="button-group-card">
        <div class="button-group-title">
          <el-button type="primary" @click="addNewMemberForRead" icon="el-icon-circle-plus">
            添加拥有权限的用户
          </el-button>
        </div>
      </div>

      <div style="margin-top: 10px;">
        <el-table :data="userCanRead" style="width: 100%;text-align: center; height: 100%; " border
                  ref="refTable" :header-cell-style="{ background: '#F2F2F2', color: '#333' }">
          <el-table-column prop="userId" label="用户id" width="80" show-overflow-tooltip align="center"/>
          <el-table-column prop="nickname" label="用户姓名" width="580" show-overflow-tooltip align="center"/>
          <el-table-column fixed="right" label="移除该用户对该页面权限" min-width="110" show-overflow-tooltip
                           align="center">
            <template v-slot="scope">
              <el-button @click="deleteProductUser(scope.row)" type="primary" size="small">移除</el-button>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <div class="button-group-card2">
        <div class="button-group-title2">
          <el-button type="primary" @click="returnBack" :plain="true">返回已发布页面列表</el-button>
        </div>
      </div>
    </div>

    <add-new-member-for-read v-if="show==2" :companyId="companyId" :productId="productId"
                         @return="comeBack"></add-new-member-for-read>
    <el-dialog
        title="提示"
        :visible.sync="deleteDialogVisible"
        width="30%"
    >
      <span>确定移除用户权限？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible=false;">取 消</el-button>
        <el-button type="primary" @click="handleDeleteProductUser">确 定</el-button>
     </span>
    </el-dialog>
  </div>
</template>

<script>
import AddNewMemberForRead from "./AddNewMemberForRead"

import API from "@/../config/api.js";
import IMGURL from "@/../config/imgUrl.js";
export default {
  props: {
    productId: Number,
    companyId: Number
  },
  components: {
    AddNewMemberForRead
  },
  data() {
    return {
      pageNum: 1,
      pages: '',
      userCanRead: [],
      pageType: '',
      userId: '',
      logoMember: IMGURL.logoMember,
      logoDelMember: IMGURL.logoDelMember,
      logoDistribute: IMGURL.logoDistribute,
      show: 1,
      deleteDialogVisible: false, //删除对话框
      deleteItem: {},
    }
  },
  mounted() {
    this.userId = window.localStorage.getItem('userid');
    this.userCanRead = []
    this.pageNum = 1
    this.getAllProjectOfUserByPermission();
  },
  methods: {
    returnBack() {
      this.$emit('return');
    },
    comeBack() {
      this.show = 1;
      this.userCanRead = [];                  //先清空表里面的人
      this.getAllProjectOfUserByPermission(); //重新加载有权限的人
    },
    //获取所有有权限的用户 后面修改
    getAllProjectOfUserByPermission() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        companyId: this.companyId,
        productId: this.productId,
      }
      this.$axiosRequest({
        url: API.getProductUserList,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          console.log(res)
          this.userCanRead = res.data["productUserList"];
        }
      });
    },
    //为用户增加可读权限,进入获取全员名单页面
    addNewMemberForRead() {
      this.show = 2;
    },
    handleDeleteProductUser(){
      let e = this.deleteItem;
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }

      let data = {
        companyId: this.companyId,
        productUserId: e.userId,
        productId: this.productId,
      }

      this.$axiosRequest({
        url: API.deleteProductUser,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          if (res.data > 0) {
            this.$message({
              message: '删除成功',
              type: 'success',
            });
            this.deleteDialogVisible = false;
            this.getAllProjectOfUserByPermission();
          } else if (res.data == 0) {
            this.$message({
              message: '不存在用户界面关系',
              type: 'warning',
            });
          } else if (res.data == -2) {
            this.$message({
              message: '参数出错',
              type: 'warning',
            });
          } else if (res.data == -1) {
            this.$message({
              message: '程序错误',
              type: 'warning',
            });
          }
        }
      });
    },
    //移除用户权限,已调通
    deleteProductUser(e) {
      this.deleteItem = e;
      this.deleteDialogVisible = true;
    },

  }
}
</script>

<style>
.button-group-card {
  margin: 10px 15px 10px 15px;
  padding: 12px;
}

.button-group-title {
  font-size: 18px;
  font-weight: bold;
}

.button-group-card2 {
  padding: 12px;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed
}

.button-group-title2 {
  font-size: 18px;
  font-weight: bold;
  width: 450px;
  margin-left: 900px;
}
</style>



